// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3yQLX","amount":"Amount_amount__22ny3","tip":"Amount_tip__LRVw2","tipHeader":"Amount_tipHeader__lXtAy","tipsWrap":"Amount_tipsWrap__3v8F4"};